const STANDARD_INPUT_VARIANT = "outlined"
const STANDARD_INPUT_SIZE = "small"

export { STANDARD_INPUT_VARIANT, STANDARD_INPUT_SIZE }
